const DEPOSIT = "http://maplays.net"

export default DEPOSIT
